<template>
    <div>
        <template
        v-if="
            cardData.mpecs &&
            cardData.mpecs.length !== 0 &&
            cardData.type_what === 'normal'
        "
        >
            <li class="card-elm-item2">
            <div v-for="(value, name, index) in cardData.mpecs" :key="index">
                <template
                v-if="
                    name === 'Voir tous les services' &&
                    (!cardData.labels || cardData.labels.length === 0)
                "
                >
                <a
                    :href="transformUrlToAbsolute(value.etb_lien)"
                    :title="value.os_title"
                    >{{ value.os_title }}</a
                >
                </template>
                <template
                v-if="
                    name !== 'Voir tous les services' &&
                    Object.keys(cardData.mpecs).length === 1 &&
                    (!cardData.labels || cardData.labels.length === 0)
                "
                >
                <strong v-if="index === 0">En fonction de votre recherche :</strong>
                <a
                    v-if="value.total === 1"
                    :href="transformUrlToAbsolute(value.os_lien)"
                    >{{ value.os_title }}
                </a>
                <a v-else :href="'/' + value.etb_lien"
                    >{{ value.service_title }} ({{ value.total }})
                </a>
                <ul class="list-uo hide">
                    <li v-for="uo in value.uo" :key="uo">
                    {{ uo }}
                    </li>
                </ul>
                </template>
                <!-- start  label highlight-->
                <template v-if="cardData.labels && cardData.labels.length !== 0">
                <div v-for="label in cardDataLabels" :key="label.etb_lien">
                    <strong>En fonction de votre recherche :</strong>
                    <a
                    v-if="label.qty > 1"
                    :href="transformUrlToAbsolute(label.etb_lien)"
                    >{{ label.titre }}
                    </a>
                    <a
                    v-if="label.qty === 1"
                    :href="transformUrlToAbsolute(label.os_lien)"
                    >{{ label.titre }}
                    </a>
                </div>
                </template>
                <!-- end label highlight-->
                <template
                v-if="
                    name !== 'Voir tous les services' &&
                    Object.keys(cardData.mpecs).length > 1
                "
                >
                <strong v-if="index === 0">En fonction de votre recherche :</strong>
                <a
                    v-if="value.total === 1"
                    :href="transformUrlToAbsolute(value.os_lien)"
                    >{{ value.service_title }} ({{ value.total }})
                </a>
                <a v-else :href="transformUrlToAbsolute(value.etb_lien)"
                    >{{ value.service_title }} ({{ value.total }})
                </a>
                </template>
            </div>
            </li>
        </template>
        <template
                v-if="
                    cardData.mpecs &&
                    cardData.mpecs.length !== 0 &&
                    cardData.type_what === 'maternite'
                "
                >
        <li
            class="card-elm-item2"
            v-if="
            cardData.mpecs[cardData.type_what] !== undefined &&
            cardData.mpecs[cardData.type_what].service_title
            "
        >
            <div
            v-for="(value, name, index) in cardData.mpecs"
            :key="value.service_title"
            >
            <strong v-if="index === 0">En fonction de votre recherche : </strong>
            <a :href="transformUrlToAbsolute(value.etb_lien)"
                >{{ value.service_title }}
            </a>
            </div>
        </li>
        </template>
                <template
                v-if="
                    cardData.mpecs &&
                    cardData.mpecs.length !== 0 &&
                    (cardData.type_what === 'urgence' ||
                    cardData.type_what === 'URGENCE')
                "
                >
        <li class="card-elm-item2">
            <div v-for="(value, name, index) in cardData.mpecs" :key="index">
            <strong v-if="index === 0">En fonction de votre recherche : </strong>
            <div>
                <p
                class="no-margin"
                v-if="value.total === 1 && value.os_telephone !== ''"
                >
                <a :href="transformUrlToAbsolute(value.os_lien)"
                    >{{ value.urgence_title }}
                </a>
                :
                <a
                    :href="
                    'tel:' +
                    value.os_telephone
                        .replace(/[^\w\s]/gi, '')
                        .split(' ')
                        .join('')
                    "
                    >{{ value.os_telephone }}</a
                >
                </p>
                <p class="no-margin" v-else>
                <a :href="transformUrlToAbsolute(value.os_lien)"
                    >{{ value.urgence_title }}
                </a>
                :
                <a
                    :href="
                    'tel:' +
                    value.etb_telephone
                        .replace(/[^\w\s]/gi, '')
                        .split(' ')
                        .join('')
                    "
                    >{{ value.etb_telephone }}</a
                >
                </p>
            </div>
            </div>
        </li>
        </template>
    </div>
</template>

<script>
import { computed } from 'vue';

export default {
  props: {
    cardData: { type: Object, default: () => ({}) },
  },
  setup(props) {
    function transformUrlToAbsolute(url) {
      if (!url || url[0] === '/') {
        return url;
      }
      return `/${url}`;
    }
    const cardDataLabels = computed(() => {
      if (!props.cardData?.labels) {
        return [];
      }
      const listLabels = Array.isArray(props.cardData.labels)
        ? props.cardData.labels
        : Object.values(props.cardData.labels);
      return listLabels.filter((label) => label.highlight > 0);
    });

    return {
      transformUrlToAbsolute,
      cardDataLabels,
    };
  },
};
</script>
